export enum ShotOutcomeEnum {
    IN = 'IN',
    LET = 'LET',
    OUT = 'OUT',
    FOOT_FAULT = 'FOOT_FAULT'
}
